<app-layout>
  <app-voltar route="listagem/empresa" />
  <div class="main">
    <div class="header-table">
      <app-titulo>Transferência de Frota</app-titulo>
    </div>

    <div class="desktop grid-outline">
      <div class="grid-header">
        <div class="intern-title">
          Transferir placas e motoristas entre empresa e avulso
        </div>
      </div>

      <app-loader [isLoading]="isLoading"></app-loader>

      <form [formGroup]="form" class="transfer-form">
        <div class="form-row">
          <app-input
            type="select"
            label="Tipo origem"
            name="NU_TIPO_ORIG"
            formControlName="NU_TIPO_ORIG"
            placeholder="Selecione"
            width="100%"
            coerceValue="number"
            [requiredInput]="true"
            [selectData]="tipoProprietarioOptions"></app-input>
          <app-input
            type="select"
            label="Tipo destino"
            name="NU_TIPO_DEST"
            formControlName="NU_TIPO_DEST"
            placeholder="Selecione"
            width="100%"
            coerceValue="number"
            [requiredInput]="true"
            [selectData]="tipoProprietarioOptions"></app-input>
        </div>

        <div class="form-row">
          <app-input
            *ngIf="!origemEhAvulso"
            type="select"
            label="Empresa origem"
            name="FK_EPSA_ORIG"
            formControlName="FK_EPSA_ORIG"
            placeholder="Selecione"
            width="100%"
            coerceValue="number"
            [requiredInput]="true"
            [selectData]="empresaOptions"></app-input>
          <div *ngIf="origemEhAvulso" class="origem-avulso">
            Origem: todos os motoristas avulsos e suas placas
          </div>
          <app-input
            *ngIf="!destinoEhAvulso"
            type="select"
            label="Empresa destino"
            name="FK_EPSA_DEST"
            formControlName="FK_EPSA_DEST"
            placeholder="Selecione"
            width="100%"
            coerceValue="number"
            [requiredInput]="true"
            [selectData]="empresaOptions"></app-input>
          <app-input
            *ngIf="destinoEhAvulso"
            type="select"
            label="Motorista avulso destino"
            name="FK_MTRT_EXTR_DEST"
            formControlName="FK_MTRT_EXTR_DEST"
            placeholder="Selecione"
            width="100%"
            coerceValue="number"
            [requiredInput]="temPlacaSelecionada"
            [selectData]="motoristaAvulsoDestinoOptions"></app-input>
        </div>

        <div class="form-row">
          <app-select-check
            label="Cavalos"
            placeholder="Selecione as placas"
            formControlName="cavalos"
            width="100%"
            [selectData]="cavaloOptions"></app-select-check>
          <app-select-check
            label="Carretas"
            placeholder="Selecione as placas"
            formControlName="carretas"
            width="100%"
            [selectData]="carretaOptions"></app-select-check>
        </div>

        <div class="form-row">
          <app-select-check
            label="Motoristas"
            placeholder="Selecione os motoristas"
            formControlName="motoristas"
            width="100%"
            [selectData]="motoristaOptions"></app-select-check>
          <app-input
            type="textarea"
            label="Observação"
            name="TX_OBSV"
            formControlName="TX_OBSV"
            placeholder="Motivo da transferência"
            width="100%"></app-input>
        </div>

        <div class="resumo">
          <p>
            <strong>Origem:</strong> {{ origemNome }} →
            <strong>Destino:</strong> {{ destinoNome }}
          </p>
          <p><strong>Itens selecionados:</strong> {{ totalSelecionados }}</p>
          <ul class="selecionados" *ngIf="totalSelecionados">
            <li *ngIf="nomesCavalosSelecionados">
              <strong>Cavalos:</strong> {{ nomesCavalosSelecionados }}
            </li>
            <li *ngIf="nomesCarretasSelecionadas">
              <strong>Carretas:</strong> {{ nomesCarretasSelecionadas }}
            </li>
            <li *ngIf="nomesMotoristasSelecionados">
              <strong>Motoristas:</strong> {{ nomesMotoristasSelecionados }}
            </li>
          </ul>
          <p class="alerta" *ngIf="origemDestinoIguais">
            A empresa destino deve ser diferente da origem.
          </p>
          <p
            class="alerta"
            *ngIf="destinoEhAvulso && temPlacaSelecionada && !form.controls.FK_MTRT_EXTR_DEST.value">
            Selecione o motorista avulso destino para transferir as placas.
          </p>
        </div>

        <div class="actions">
          <app-botao
            text="Transferir"
            [disabled]="!podeTransferir"
            (click)="confirmarTransferencia()"></app-botao>
        </div>
      </form>

      <div class="resultado" *ngIf="resultado">
        <div class="resultado-bloco sucesso" *ngIf="resultado.Sucesso?.length">
          <h3>Transferidos ({{ resultado.Sucesso.length }})</h3>
          <ul>
            <li *ngFor="let item of resultado.Sucesso">
              {{ item.TX_IDNT }} — {{ item.TX_MENS }}
            </li>
          </ul>
        </div>
        <div
          class="resultado-bloco bloqueado"
          *ngIf="resultado.Bloqueados?.length">
          <h3>Bloqueados ({{ resultado.Bloqueados.length }})</h3>
          <ul>
            <li *ngFor="let item of resultado.Bloqueados">
              {{ item.TX_IDNT || ('Item ' + item.FK_ENTD) }} —
              {{ item.TX_MENS }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</app-layout>
